<template>
  <div>
    <v-app-bar
      v-if="showAppBar"
      :color="appBarColor"
      :elevation="elevation"
      app
      fixed
      dense
      :class="{ 'app-bar-shadow': isScrolled }"
    >
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <!-- Title for mobile/small screens -->
        <span class="d-block d-sm-none">Document Management</span>

        <!-- Icons wrapper with responsive display -->
        <div class="d-none d-sm-block">
          <!-- Statistics Buttons -->

          <!-- Dashboard Button -->
          <!-- <v-tooltip bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/dashboard"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-monitor-dashboard</v-icon>
              </v-btn>
            </template>
            <span>Dashboard</span>
          </v-tooltip> -->

          <!-- Home Button -->
          <v-tooltip bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/home"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-home-circle</v-icon>
              </v-btn>
            </template>
            <span> Home</span>
          </v-tooltip>

          <!-- Listing Button -->
          <v-tooltip bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/listing"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-format-list-bulleted</v-icon></v-btn
              >
            </template>
            <span> Listing</span>
          </v-tooltip>

          <!-- Report Button -->
          <!-- <v-tooltip bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/reports"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-clipboard-file</v-icon></v-btn
              >
            </template>
            <span>Basic Report Generator</span>
          </v-tooltip> -->

          <!-- Report Button Two-->
          <!-- <v-tooltip bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/reportsTwo"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-clipboard-search</v-icon></v-btn
              >
            </template>
            <span>Detail Report Generator</span>
          </v-tooltip> -->

          <!-- Report Button Two-->
          <v-tooltip bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/reportsV1"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-clipboard-search</v-icon></v-btn
              >
            </template>
            <span>Search Reports</span>
          </v-tooltip>

          <!-- Claims Dropdown -->
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tooltip bottom transition="fab-transition">
                <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                  <v-btn
                    v-bind="{ ...attrs, ...tooltipAttrs }"
                    v-on="{ ...on, ...tooltipOn }"
                    color="indigo"
                    icon
                    style="text-decoration: none"
                  >
                    <v-icon>mdi-file-document-multiple</v-icon>
                  </v-btn>
                </template>
                <span>Claims</span>
              </v-tooltip>
            </template>
            <v-list dense>
              <v-list-item to="/claimsv3">
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item>
              <v-list-item to="/claimsv3/bookkeeping">
                <v-list-item-title>Bookkeeping</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Merimen Button -->
          <v-tooltip v-if="showMerimen" bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/merimen-data"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-inbox-arrow-down</v-icon></v-btn
              >
            </template>
            <span>Merimen</span>
          </v-tooltip>

          <!-- Compliance Button -->
          <v-tooltip v-if="showCompliance" bottom transition="fab-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="indigo"
                to="/compliance"
                icon
                style="text-decoration: none"
              >
                <v-icon>mdi-shield-check</v-icon></v-btn
              >
            </template>
            <span>Compliance</span>
          </v-tooltip>
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Custom dropdown menu instead of v-menu -->
      <div class="custom-dropdown-container">
        <div
          class="profile-btn"
          @click="toggleProfileMenu"
          @mouseenter="showProfileMenu"
        >
          <v-avatar size="36px">
            <v-img
              :src="profileImageUrl"
              :alt="currentUser.username"
              @error="handleAvatarError"
            >
              <template v-slot:placeholder>
                <v-icon>mdi-account</v-icon>
              </template>
            </v-img>
          </v-avatar>
        </div>

        <div
          class="dropdown-content"
          :class="{ show: isProfileMenuVisible }"
          @mouseenter="cancelHideMenu"
          @mouseleave="delayHideMenu"
          @click="hideProfileMenu"
        >
          <!-- Welcome link (added) -->
          <router-link
            to="/welcome"
            class="dropdown-item"
            @click="hideProfileMenu"
          >
            <v-icon color="indigo">mdi-hand-wave</v-icon>
            <span>Welcome</span>
          </router-link>

          <div class="dropdown-divider"></div>

          <router-link
            to="/profile"
            class="dropdown-item"
            @click="hideProfileMenu"
          >
            <v-icon color="indigo">mdi-account-circle</v-icon>
            <span>My Profile</span>
          </router-link>

          <router-link
            to="/mytasks"
            class="dropdown-item"
            @click="hideProfileMenu"
          >
            <v-icon color="indigo">mdi-clipboard-check</v-icon>
            <span>My Tasks</span>
          </router-link>

          <div class="dropdown-divider" v-if="showSuperAdminBoard"></div>

          <router-link
            v-if="showSuperAdminBoard"
            to="/management"
            class="dropdown-item"
            @click="hideProfileMenu"
          >
            <v-icon color="indigo">mdi-shield-crown</v-icon>
            <span>Management</span>
          </router-link>
        </div>
      </div>

      <div v-if="!currentUser">
        <v-btn to="/login" class="text-decoration-none" plain
          ><font-awesome-icon icon="sign-in-alt" />Login
        </v-btn>
      </div>

      <div v-else>
        <v-tooltip bottom transition="fab-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click.prevent="logOut"
              v-bind="attrs"
              v-on="on"
              icon
              style="text-decoration: none"
            >
              <v-icon>mdi-logout-variant</v-icon></v-btn
            >
          </template>
          <span>Logout</span>
        </v-tooltip>
      </div>
    </v-app-bar>

    <v-navigation-drawer
      v-if="currentUser"
      v-model="drawer"
      app
      temporary
      expand-on-hover
      dark
      class="gradient-drawer-bg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ currentUser.username }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ currentUser.email }}
            </v-list-item-subtitle>
            <v-divider></v-divider>
            <v-list-item-subtitle class="text-h7">
              <strong>Access:</strong>
            </v-list-item-subtitle>

            <v-list-item-subtitle class="text-h8">
              <ul>
                <li v-for="(role, index) in currentUser.roles" :key="index">
                  {{ role }}
                </li>
              </ul>
            </v-list-item-subtitle>

            <div v-if="currentUser.branches && currentUser.branches.length">
              <v-list-item-subtitle class="text-h7">
                <strong>Branch:</strong>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-h7">
                <ul>
                  <li v-for="(j, index) in currentUser.branches" :key="index">
                    <div v-for="(k, index) in filterStates(j)" :key="index">
                      {{ k.name.toUpperCase() }}
                    </div>
                  </li>
                </ul>
              </v-list-item-subtitle>
            </div>
            <div v-if="currentUser.dept && currentUser.dept.length">
              <v-list-item-subtitle class="text-h7">
                <strong>Department:</strong>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-h7">
                <ul>
                  <li v-for="(i, index) in currentUser.dept" :key="index">
                    <div v-for="(m, index) in filterDept(i)" :key="index">
                      {{ m.name.toUpperCase() }}
                    </div>
                  </li>
                </ul>
              </v-list-item-subtitle>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <!-- admin links -->
      <v-list v-if="showAdminBoard" nav dense>
        <div v-for="(link, i) in adminlinks" :key="i">
          <v-list-group
            v-if="link.subLinks"
            :key="link.text"
            no-action
            :prepend-icon="link.icon"
            :value="activeMenu === 'admin'"
            @click="handleMenuClick('admin')"
            active-class="white--text"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="sublink in link.subLinks"
              :to="sublink.to"
              :key="sublink.text"
              class="text-decoration-none pl-5"
              active-class="white--text"
            >
              <v-list-item-icon>
                <v-icon>{{ sublink.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ sublink.text }}</v-list-item-title>
            </v-list-item>
            <!-- Management link — super-admin only -->
            <v-list-item
              v-if="showSuperAdminBoard"
              to="/management"
              class="text-decoration-none pl-5"
              active-class="white--text"
            >
              <v-list-item-icon>
                <v-icon>mdi-shield-crown</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Management</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>

      <!-- User Links -->
      <v-list nav dense>
        <div v-for="(link, i) in links" :key="i">
          <v-list-group
            :key="link.text"
            no-action
            :prepend-icon="link.icon"
            :value="activeMenu === 'dashboard'"
            @click="handleMenuClick('dasboard')"
            active-class="white--text"
          >
            <template v-slot:activator>
              <v-list-item-title>{{ link.text }}</v-list-item-title>
            </template>

            <v-list-item
              v-for="sublink in filteredSubLinks(link)"
              :to="sublink.to"
              :key="sublink.text"
              class="text-decoration-none pl-5"
              active-class="white--text"
            >
              <v-list-item-icon>
                <v-icon>{{ sublink.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ sublink.text }}</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>
      <!-- <v-btn text :to="{ name: 'listing' }">Listing</v-btn> -->
    </v-navigation-drawer>

    <!-- Inactivity Warning Dialog (Version 2 UI/UX) -->
    <v-dialog v-model="showInactivityWarning" max-width="380">
      <v-card class="pa-4" style="background: #f9fafb">
        <v-card-title class="justify-center pb-2">
          <v-icon color="warning" size="36">mdi-alert-circle</v-icon>
        </v-card-title>
        <v-card-title
          class="headline font-weight-bold justify-center"
          style="color: #333"
        >
          Are you still there?
        </v-card-title>
        <v-divider class="my-2"></v-divider>
        <v-card-text class="text-center" style="color: #555">
          For your security, you will be logged out in
          <span class="font-weight-bold" style="color: #1976d2">
            {{ remainingWarningSeconds }}
          </span>
          seconds due to inactivity.
        </v-card-text>
        <v-card-actions class="justify-center mt-2">
          <v-btn color="primary" class="px-6" @click="stayLoggedIn" depressed>
            Stay Logged In
          </v-btn>
          <v-btn text color="grey darken-1" class="ml-2" @click="logOut">
            Logout Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BranchDataService from "../services/BranchDataService";
import DeptDataService from "../services/DeptDataService";
import EventBus from "../common/EventBus";
import { apiConfig } from "../config/api.config"; // <-- Add this import
import { logEvent } from "@/utils/logEvent";

export default {
  // no local components
  name: "appBar",

  data: () => ({
    searchId: "",
    drawer: false,
    profileMenu: false,
    adminlinks: [
      {
        icon: "mdi-shield-lock-outline",
        text: "Admin",
        subLinks: [
          {
            text: "User",
            to: "/members",
            icon: "mdi-account-group", // Users/members icon
          },
          {
            text: "Branch",
            to: "/branches",
            icon: "mdi-office-building", // Building/branch icon
          },
          {
            text: "Department",
            to: "/depts",
            icon: "mdi-domain", // Organization/department icon
          },
          {
            text: "File Classification",
            to: "/subDepts",
            icon: "mdi-file-tree", // File hierarchy icon
          },
          {
            text: "State",
            to: "/states",
            icon: "mdi-map-marker", // Location/state icon
          },
          {
            text: "District",
            to: "/districts",
            icon: "mdi-map", // Region/district icon
          },
          {
            text: "Insurer",
            to: "/inss",
            icon: "mdi-shield-check", // Insurance/protection icon
          },
          {
            text: "TAT List",
            to: "/tatcharts",
            icon: "mdi-clock-outline", // Time/duration icon
          },
          {
            text: "Handler",
            to: "/handlers",
            icon: "mdi-account-tie", // Professional/handler icon
          },
          {
            text: "Bulletin",
            to: "/bulletins",
            icon: "mdi-bulletin-board", // Bulletin board icon
          },
        ],
      },
    ],

    links: [
      {
        icon: "mdi-menu",
        text: "Navigation",
        subLinks: [
          // {
          //   to: "/dashboard",
          //   icon: "mdi-monitor-dashboard",
          //   text: "Dashboard",
          // },
          {
            to: "/home",
            icon: "mdi-home-circle-outline",
            text: "Home",
          },
          // {
          //   to: "/caselist",
          //   icon: "mdi-format-list-bulleted",
          //   text: "Case List",
          // },
          {
            to: "/listing",
            icon: "mdi-format-list-bulleted",
            text: "Listing",
          },
          // {
          //   to: "/reports",
          //   icon: "mdi-clipboard-file",
          //   text: "Basic Report Generator",
          // },
          // {
          //   to: "/reportsTwo",
          //   icon: "mdi-clipboard-search",
          //   text: "Detail Report Generator",
          // },
          {
            to: "/reportsV1",
            icon: "mdi-clipboard-search",
            text: "Search Reports",
          },
          {
            to: "/claimsv3",
            icon: "mdi-file-document-multiple",
            text: "Claims Dashboard",
          },
          {
            to: "/claimsv3/bookkeeping",
            icon: "mdi-book-open-variant",
            text: "Claims Bookkeeping",
          },
          {
            text: "Merimen",
            to: "/merimen-data",
            icon: "mdi-inbox-arrow-down",
          },
          // Only show Compliance if allowed
          {
            to: "/compliance",
            icon: "mdi-shield-check",
            text: "Compliance",
            // show: () => this.showCompliance,
          },
          // {
          //   to: "/docs",
          //   icon: "mdi-book-open-variant",
          //   text: "Docs",
          // },
        ],
      },
    ],
    // specialLinks: [
    //   {
    //     to: "/dropboxfiles",
    //     icon: "mdi-dropbox",
    //     text: "Dropbox",
    //   },
    // ],
    branches: [],
    departments: [],
    activeMenu: null, // Add this to track which menu is active
    isScrolled: false,
    elevation: 1,
    appBarColor: "transparent",
    isProfileMenuVisible: false, // Add this to track profile menu visibility
    avatarErrored: false, // Add this property
    inactivityTimeout: null,
    inactivityLimit: 30000, // default, will be overwritten by Vuex
    warningDelayLimit: 20000, // default, will be overwritten by Vuex
    inactivityEnabled: false, // default, will be overwritten by Vuex
    warningTimeout: null,
    showInactivityWarning: false,
    warningCountdown: 0,
    warningInterval: null,
    warningActive: false, // NEW: track if warning is active
    boundResetInactivity: null,
  }),

  computed: {
    currentUser() {
      return this.$store.getters["auth/currentUserSafe"];
    },
    showAppBar() {
      // Hide appBar on login, forgot, reset, activate pages
      const publicPages = ["/login", "/forgot", "/reset", "/activate"];
      return !publicPages.includes(this.$route.path);
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ADMIN");
      }

      return false;
    },
    showSuperAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("SUPER_ADMIN");
      }

      return false;
    },
    // showDropBox() {
    //   if (this.currentUser && this.currentUser.roles) {
    //     let result = this.currentUser.roles.filter(
    //       (data) =>
    //         data.includes("ADMIN") ||
    //         // data.includes("BRANCHMANAGER") ||
    //         // data.includes("BRANCHCLERK") ||
    //         data.includes("CLERK")
    //     );
    //     if (result.length > 0) {
    //       return true;
    //     }
    //   }

    //   return false;
    // },
    showMerimen() {
      if (this.currentUser && this.currentUser.roles) {
        return (
          this.currentUser.roles.includes("ADMIN") ||
          this.currentUser.roles.includes("MANAGER") ||
          this.currentUser.roles.includes("CLERK")
        );
      }
      return false;
    },
    showCompliance() {
      if (this.currentUser && this.currentUser.roles) {
        return (
          this.currentUser.roles.includes("ADMIN") ||
          this.currentUser.roles.includes("MANAGER") ||
          this.currentUser.roles.includes("CLERK")
        );
      }
      return false;
    },
    // showManagerBoard() {
    //   if (this.currentUser && this.currentUser.roles) {
    //     return this.currentUser.roles.includes("MANAGER");
    //   }

    //   return false;
    // },
    profileImageUrl() {
      if (
        this.avatarErrored ||
        !this.currentUser ||
        !this.currentUser.profile
      ) {
        // Return empty string to trigger placeholder (mdi-account)
        return "";
      }
      return `${apiConfig.uploadsPath}${this.currentUser.profile}`;
    },
    remainingWarningSeconds() {
      return Math.max(
        Math.ceil(
          (this.inactivityLimit -
            this.warningDelayLimit -
            this.warningCountdown) /
            1000,
        ),
        1,
      );
    },
    inactivitySettings() {
      return this.$store.getters["settings/inactivitySettings"];
    },
  },
  methods: {
    filterStates(item) {
      return this.branches.filter((branch) => branch.id === item);
    },
    filterDept(item) {
      return this.departments.filter((dept) => dept.id === item);
    },
    retrieveStates() {
      BranchDataService.getAll()
        .then((response) => {
          this.branches = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    retrieveDepts() {
      DeptDataService.getAll()
        .then((response) => {
          this.departments = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // onEnter: function (value) {
    //   this.$router.push({
    //     name: "file",
    //     params: { id: value },
    //   });
    // },
    async logOut() {
      // Capture user info before logout
      const user = this.$store.state.auth.user;
      // Immediately clear user and redirect
      this.$store.dispatch("auth/logout");
      if (this.$route.path !== "/login") {
        this.$router.push("/login");
      }
      this.$store.dispatch("setSnackbar", {
        showing: true,
        color: "success",
        text: "Successfully Logged Out!",
      });
      // Fire-and-forget: log event and backend logout
      logEvent({
        action: "logout",
        eventTitle: "User Logout",
        user: user,
        status: "success",
        meta: {
          ip: window?.location?.hostname || "",
          userAgent: navigator.userAgent,
          source: "frontend",
        },
      }).catch(() => {});
      // Optionally: call backend logout directly if not handled in store
      // (If your store's logout action already calls backend, skip this)
      // import AuthService from "../services/auth.service";
      // AuthService.logout().catch(() => {});
      this.showInactivityWarning = false; // Hide warning dialog on logout
      this.warningActive = false;
    },
    // Add new method to handle menu clicks
    handleMenuClick(menuName) {
      if (this.activeMenu === menuName) {
        this.activeMenu = null;
      } else {
        this.activeMenu = menuName;
      }
    },
    filteredSubLinks(link) {
      // Only show sublinks that either have no "show" property or their "show" returns true
      // Remove the check for sublink.show()
      return link.subLinks.filter(
        (sublink) =>
          (sublink.text !== "Merimen" || this.showMerimen) &&
          (sublink.text !== "Compliance" || this.showCompliance),
      );
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
      this.elevation = this.isScrolled ? 6 : 1;
      this.appBarColor = this.isScrolled ? "white" : "transparent";
    },
    handleAvatarError() {
      this.avatarErrored = true;
    },
    // Add methods to handle profile menu visibility
    toggleProfileMenu() {
      this.isProfileMenuVisible = !this.isProfileMenuVisible;
    },
    showProfileMenu() {
      this.isProfileMenuVisible = true;
    },
    hideProfileMenu() {
      this.isProfileMenuVisible = false;
    },
    handleGlobalClick(event) {
      const container = this.$el.querySelector(".custom-dropdown-container");
      if (container && !container.contains(event.target)) {
        this.hideProfileMenu();
      }
    },
    cancelHideMenu() {
      clearTimeout(this.hideMenuTimeout);
    },
    delayHideMenu() {
      this.hideMenuTimeout = setTimeout(() => {
        this.isProfileMenuVisible = false;
      }, 300);
    },
    onSettingsSaved() {
      // Update Vuex store and timers
      this.$store.dispatch("settings/fetchSettings").then(() => {
        this.applySettingsFromStore();
        this.resetInactivityTimer();
      });
    },
    async applySettingsFromStore() {
      // Always use Vuex/global settings
      const opts = this.inactivitySettings;
      this.inactivityEnabled = !!opts.inactivityEnabled;
      this.inactivityLimit = Number(opts.inactivityLimit || 30) * 1000;
      this.warningDelayLimit = Number(opts.warningDelayLimit || 20) * 1000;
    },
    startInactivityTimer() {
      this.clearInactivityTimer();
      // Only start timers when inactivity is enabled and a user is logged in
      if (!this.inactivityEnabled || !this.$store.state.auth.user) return;
      // Start warning timer
      this.warningTimeout = setTimeout(() => {
        // Only show the warning if a user is still logged in
        if (!this.$store.state.auth.user) return;
        this.showInactivityWarning = true;
        this.warningActive = true;
        this.warningCountdown = 0;
        this.startWarningCountdown();
      }, this.warningDelayLimit);

      // Start logout timer
      this.inactivityTimeout = setTimeout(() => {
        this.logOut();
      }, this.inactivityLimit);
    },
    clearInactivityTimer() {
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout);
        this.inactivityTimeout = null;
      }
      if (this.warningTimeout) {
        clearTimeout(this.warningTimeout);
        this.warningTimeout = null;
      }
      this.clearWarningCountdown();
      this.showInactivityWarning = false; // Always hide dialog when clearing timers
      this.warningActive = false;
    },
    resetInactivityTimer() {
      // Only reset timer for authenticated users; also avoid resetting while warning dialog is active
      if (!this.$store.state.auth.user) return;
      if (!this.showInactivityWarning) {
        this.clearInactivityTimer();
        this.startInactivityTimer();
      }
      // If warning dialog is open, do not reset on activity
    },
    stayLoggedIn() {
      this.showInactivityWarning = false;
      this.warningActive = false;
      this.resetInactivityTimer();
    },
    startWarningCountdown() {
      this.clearWarningCountdown();
      this.warningCountdown = 0;
      this.warningInterval = setInterval(() => {
        this.warningCountdown += 1000;
        if (
          this.warningCountdown >=
          this.inactivityLimit - this.warningDelayLimit
        ) {
          this.clearWarningCountdown();
        }
      }, 1000);
    },
    clearWarningCountdown() {
      if (this.warningInterval) {
        clearInterval(this.warningInterval);
        this.warningInterval = null;
      }
      this.warningCountdown = 0;
    },
    // ...existing code...
  },
  watch: {
    $route() {
      this.hideProfileMenu();
    },
  },
  async mounted() {
    this.retrieveStates();
    this.retrieveDepts();
    EventBus.on("logout", () => {
      this.logOut();
    });
    window.addEventListener("scroll", this.handleScroll);

    // Global click handler to close dropdown when clicking outside
    this.boundHandleGlobalClick = this.handleGlobalClick.bind(this);
    document.addEventListener("click", this.boundHandleGlobalClick, true);

    // Inactivity timer setup
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    // bind the handler so `this` inside the handler refers to the Vue instance
    this.boundResetInactivity = this.resetInactivityTimer.bind(this);
    events.forEach((evt) =>
      window.addEventListener(evt, this.boundResetInactivity),
    );
    // Fetch settings from backend and apply
    await this.$store.dispatch("settings/fetchSettings");
    await this.applySettingsFromStore();
    // Listen for settings changes from management-settings
    EventBus.on("settings-saved", this.onSettingsSaved);
    this.startInactivityTimer();
  },
  beforeDestroy() {
    EventBus.remove("logout");
    EventBus.remove("settings-saved", this.onSettingsSaved);
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.boundHandleGlobalClick, true);

    // Remove inactivity listeners
    const events = ["mousemove", "keydown", "mousedown", "touchstart"];
    // remove the previously bound handler
    events.forEach((evt) =>
      window.removeEventListener(evt, this.boundResetInactivity),
    );
    this.clearInactivityTimer();
  },
};
</script>

<style>
.app-bar-shadow {
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.9) !important;
}

/* Custom gradient background for navigation drawer */
.gradient-drawer-bg {
  background: linear-gradient(135deg, #283e51 0%, #485563 100%) !important;
}

/* Custom dropdown styles */
.custom-dropdown-container {
  position: relative;
  display: inline-block;
}

/* Bridge element to eliminate gap between avatar and dropdown */
.custom-dropdown-container::before {
  content: '';
  position: absolute;
  right: 0;
  bottom: 100%;
  width: 36px;
  height: 4px;
  background: transparent;
  z-index: 999;
  pointer-events: none;
}

.profile-btn {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.profile-btn:hover {
  transform: scale(1.05);
}

.dropdown-content {
  position: absolute;
  right: 0;
  top: calc(100% - 2px);
  background-color: white;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  border-radius: 8px;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.dropdown-content.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-header {
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f5f5f5;
}

.dropdown-avatar {
  margin-right: 10px;
}

.dropdown-user-info {
  display: flex;
  flex-direction: column;
}

.username {
  font-weight: bold;
}

.email {
  font-size: 0.9em;
  color: gray;
}

.dropdown-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 5px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px;
  text-decoration: none;
  color: black;
  transition: background-color 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}

.dropdown-item .v-icon {
  margin-right: 10px;
}

/* Inactivity Warning Dialog Styles */
.v-dialog {
  backdrop-filter: blur(5px);
}

.v-card {
  border-radius: 12px;
}

.v-card-title {
  font-weight: 500;
}

.v-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 10px 0;
}
</style>
